import { type RouteRecordRaw } from 'vue-router'

export interface RouteParams {
    'asset-group.group-characteristics': { portfolio_id: string, asset_group_id: string }
    'asset-group.asset-list': { portfolio_id: string, asset_group_id: string }
}

/**
 * Asset group routes for collection mode
 */
export const assetGroupCollectionRoutes: RouteRecordRaw[] = [
    {
        path: 'portfolio/:portfolio_id/asset-group/:asset_group_id',
        component: () => import('@/vue/pages/collection/asset-group/Layout.vue'),
        children: [
            {
                path: '',
                redirect: { name: 'asset-group.group-characteristics' },
            },
            {
                path: 'characteristics',
                component: () => import('@/vue/pages/asset/groups/AssetGroupCharacteristicsPage.vue'),
                name: 'asset-group.group-characteristics',
                meta: {
                    title: 'asset-group.group-characteristics',
                },
            },
            {
                path: 'assets',
                component: () => import('@/vue/pages/asset/groups/AssetGroupAssetListPage.vue'),
                name: 'asset-group.asset-list',
                meta: {
                    title: 'asset-group.assets',
                },
            },
        ],
    },
]

